var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"loading",class:{'full-screen': _vm.fullScreen}},[_c('b-icon',{attrs:{"icon":"arrow-clockwise","animation":"spin"}}),(!_vm.noText)?_c('div',[_vm._v("Chargement des données...")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }